import React, { useEffect, useState } from "react";
import LinkHandler from "./LinkHandler";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  return (
    <LinkHandler href="/" className={`scroll-to-top ${showButton ? "visible" : ""}`} >
      <i className="fa fa-arrow-up"></i>
    </LinkHandler>
  );
};

export default ScrollToTopButton;
